(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector(".section-header");
      this.imageDk = this.querySelector('.ff-image-dk');
      this.imageMb = this.querySelector('.ff-image-mb');
      this.menuTitles = this.querySelectorAll('.ff-title-menu');
      this.announcement = document.querySelector('.ff-layout-section');
      this.mainContent = document.getElementById("MainContent");
      this.ffMenu = this.querySelector("ff-menu");
      this.fullHeader = document.querySelector('.ff-announcement-menu');
      this.isIndexPage = (window.location.pathname == '/');

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.pos = "";

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.defaultPosition();
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      const handlePagesHeader = this.dataset.handlePages.split(",")

      if (this.dataset.template !== "index" && this.announcement && this.mainContent) {
        if (!handlePagesHeader.includes(this.dataset.page)) {
          let heightAnnouncement = this.announcement.offsetHeight;
          let heightHeader = this.header.offsetHeight;
          this.mainContent.style.paddingTop = `${heightAnnouncement + heightHeader + 20}px`
        }
      };
      this.createObserver();
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    defaultPosition() {
      this.pos = (this.ffMenu.getBoundingClientRect().top-this.ffMenu.getBoundingClientRect().height) + 5;
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (window.pageYOffset === 0) {
        this.fullHeader.classList.add('bg-transparent');
        this.fullHeader.classList.remove('bg-white');

        for (const title of this.menuTitles) {
          title.removeAttribute("style");
        }
        if (this.imageDk){
          this.imageDk.style.paddingBottom = `10px`;
          this.imageDk.style.paddingTop = `10px`;
          this.imageDk.style.transition = "all .5s ease";
        }
        
        if (this.imageDk.src !== this.dataset.imageBannerDk || this.imageMb.src !== this.dataset.imageBannerMb) {
          if(document.body.classList.contains('index')) {
            this.imageDk.src = this.dataset.imageBannerDk;
            this.imageMb.src = this.dataset.imageBannerMb;  
          }
        }
      } else if(window.pageYOffset > 0 ){
        this.fullHeader.classList.remove('bg-transparent');
        this.fullHeader.classList.add('bg-white');
        for (const title of this.menuTitles) {
          title.style.color = this.dataset.colorTextBg;
        }
        if (this.imageDk){
          this.imageDk.style.paddingBottom = `initial`;
        }
       
        if (this.imageDk.src !== this.dataset.imageBannerBgDk || this.imageMb.src !== this.dataset.imageBannerBgMb) {
          this.imageDk.src = this.dataset.imageBannerBgDk;
          this.imageMb.src = this.dataset.imageBannerBgMb;
        }
      };  
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tao-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
  
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();
})();
